export default __webpack_public_path__ + "static/check-circle-12fbaf60dd2de238ad0750c667e5ebe2.svg";